var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container brew-content"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('h1',[_vm._v(_vm._s(_vm.content.title))])]),_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.content.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }